export default "__VITE_ASSET__EGgQUmyE__"